var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "活动名称", prop: "activityName" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.activityName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "activityName", $$v)
              },
              expression: "form.activityName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "可膨胀券", prop: "couponStartId" } },
        [
          _vm.typeName1 == ""
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    placeholder: "请输入礼券，支持模糊查询",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.fetchCoupons1,
                    loading: _vm.couponLoading,
                    disabled: !!_vm.form.id,
                  },
                  model: {
                    value: _vm.form.couponStartId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "couponStartId", $$v)
                    },
                    expression: "form.couponStartId",
                  },
                },
                _vm._l(_vm.couponOptions1, function (coupon) {
                  return _c("el-option", {
                    key: coupon.thirdCouponId,
                    attrs: {
                      label: coupon.typeName,
                      value: coupon.thirdCouponId,
                    },
                  })
                }),
                1
              )
            : _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.typeName1,
                  callback: function ($$v) {
                    _vm.typeName1 = $$v
                  },
                  expression: "typeName1",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "膨胀后的券", prop: "couponEndId" } },
        [
          _vm.typeName2 == ""
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    placeholder: "请输入礼券，支持模糊查询",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.fetchCoupons2,
                    loading: _vm.couponLoading,
                    disabled: !!_vm.form.id,
                  },
                  model: {
                    value: _vm.form.couponEndId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "couponEndId", $$v)
                    },
                    expression: "form.couponEndId",
                  },
                },
                _vm._l(_vm.couponOptions2, function (coupon) {
                  return _c("el-option", {
                    key: coupon.thirdCouponId,
                    attrs: {
                      label: coupon.typeName,
                      value: coupon.thirdCouponId,
                    },
                  })
                }),
                1
              )
            : _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.typeName2,
                  callback: function ($$v) {
                    _vm.typeName2 = $$v
                  },
                  expression: "typeName2",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "分享人限制" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.isMember,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "isMember", $$v)
                },
                expression: "form.isMember",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部会员")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("按等级")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.isMember === 1
        ? _c(
            "el-form-item",
            { attrs: { label: "分享人等级" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.gradeId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "gradeId", $$v)
                    },
                    expression: "form.gradeId",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: 1 } }, [_vm._v("普卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 2 } }, [_vm._v("银卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 3 } }, [_vm._v("金卡")]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 4 } }, [
                    _vm._v("黑金卡"),
                  ]),
                  _vm._v(" "),
                  _c("el-checkbox", { attrs: { label: 5 } }, [
                    _vm._v("钻石卡"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "分享人是否企微" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.isQw,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "isQw", $$v)
                },
                expression: "form.isQw",
              },
            },
            [
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "新人膨胀券", prop: "shareCouponId" } },
        [
          _vm.typeName3 == ""
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "300px" },
                  attrs: {
                    placeholder: "请输入礼券，支持模糊查询",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.fetchCoupons3,
                    loading: _vm.couponLoading,
                  },
                  model: {
                    value: _vm.form.shareCouponId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "shareCouponId", $$v)
                    },
                    expression: "form.shareCouponId",
                  },
                },
                _vm._l(_vm.couponOptions3, function (coupon) {
                  return _c("el-option", {
                    key: coupon.thirdCouponId,
                    attrs: {
                      label: coupon.typeName,
                      value: coupon.thirdCouponId,
                    },
                  })
                }),
                1
              )
            : _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: { disabled: "" },
                model: {
                  value: _vm.typeName3,
                  callback: function ($$v) {
                    _vm.typeName3 = $$v
                  },
                  expression: "typeName3",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "新人分享券", prop: "newCouponId" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: "请输入礼券，支持模糊查询",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": _vm.fetchCoupons4,
                loading: _vm.couponLoading,
              },
              model: {
                value: _vm.form.newCouponId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "newCouponId", $$v)
                },
                expression: "form.newCouponId",
              },
            },
            _vm._l(_vm.couponOptions4, function (coupon) {
              return _c("el-option", {
                key: coupon.thirdCouponId,
                attrs: { label: coupon.typeName, value: coupon.thirdCouponId },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "block", "margin-top": "20px" } },
            [
              _vm._v("\n            每个分享库存："),
              _c("el-input", {
                staticStyle: { width: "80px" },
                model: {
                  value: _vm.form.newCouponCount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "newCouponCount", $$v)
                  },
                  expression: "form.newCouponCount",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "20px",
                  },
                },
                [
                  _vm._v("\n                总库存："),
                  _c("el-input", {
                    staticStyle: { width: "80px" },
                    model: {
                      value: _vm.form.newCouponTotalCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newCouponTotalCount", $$v)
                      },
                      expression: "form.newCouponTotalCount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "老人分享券", prop: "oldCouponId" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: "请输入礼券，支持模糊查询",
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": _vm.fetchCoupons5,
                loading: _vm.couponLoading,
              },
              model: {
                value: _vm.form.oldCouponId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "oldCouponId", $$v)
                },
                expression: "form.oldCouponId",
              },
            },
            _vm._l(_vm.couponOptions5, function (coupon) {
              return _c("el-option", {
                key: coupon.thirdCouponId,
                attrs: { label: coupon.typeName, value: coupon.thirdCouponId },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "block", "margin-top": "20px" } },
            [
              _vm._v("\n            每个分享库存："),
              _c("el-input", {
                staticStyle: { width: "80px" },
                model: {
                  value: _vm.form.oldCouponCount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "oldCouponCount", $$v)
                  },
                  expression: "form.oldCouponCount",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "20px",
                  },
                },
                [
                  _vm._v("\n                总库存："),
                  _c("el-input", {
                    staticStyle: { width: "80px" },
                    model: {
                      value: _vm.form.oldCouponTotalCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "oldCouponTotalCount", $$v)
                      },
                      expression: "form.oldCouponTotalCount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "老用户每月领取上限", prop: "oldReceiveCount" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.oldReceiveCount,
              callback: function ($$v) {
                _vm.$set(_vm.form, "oldReceiveCount", $$v)
              },
              expression: "form.oldReceiveCount",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动时间", prop: "time" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.begType,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "begType", $$v)
                },
                expression: "form.begType",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("长期")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("快闪")]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.begType == 0
            ? _c("el-date-picker", {
                staticStyle: { display: "block" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "膨胀分享卡片", prop: "registerShareImg" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "icon-uploader",
              attrs: {
                "file-list": _vm.fileList,
                size: "mini",
                action: "#",
                "list-type": "picture-card",
                limit: 1,
                "on-remove": function () {
                  return _vm.handleUploadRemove(1)
                },
                "auto-upload": true,
                accept: "image/*",
                "http-request": _vm.handleCustomUpload,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(500px * 400px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "膨胀分享标题", prop: "registerShareTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.registerShareTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "registerShareTitle", $$v)
              },
              expression: "form.registerShareTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "用券分享卡片", prop: "orderShareImg" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                action: "#",
                "http-request": _vm.handleCustomUpload2,
                limit: 1,
                "on-remove": function () {
                  return _vm.handleUploadRemove(2)
                },
                "list-type": "picture-card",
                "auto-upload": true,
                accept: "image/*",
                "file-list": _vm.fileList2,
              },
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { color: "#999", "font-size": "12px" } }, [
            _vm._v("(500px * 400px)"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "用券分享标题", prop: "orderShareTitle" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.orderShareTitle,
              callback: function ($$v) {
                _vm.$set(_vm.form, "orderShareTitle", $$v)
              },
              expression: "form.orderShareTitle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "活动状态" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未启用")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }